import { render, staticRenderFns } from "./ArvandGatewayTransactionsPrintHtml.vue?vue&type=template&id=c0df939a&scoped=true"
import script from "./ArvandGatewayTransactionsPrintHtml.vue?vue&type=script&lang=js"
export * from "./ArvandGatewayTransactionsPrintHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0df939a",
  null
  
)

export default component.exports